import React from 'react';
import ValidationElement from '../ValidationElement';
import Text from '../Text';

export default class City extends ValidationElement {
  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `city.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  render() {
    const klass = `city usa-form-control ${this.props.className || ''}`.trim();

    let changeablePlaceholder = this.props.placeholder;
    if (this.props.showDisabledText && this.props.value && this.props.disabled) {
      changeablePlaceholder = this.props.value;
    }

    // If UTF-8 or extended ascii characters are permitted for names this may need to be reworked.
    const pattern = '^[0-9A-Za-z.,()\' -]*$';
    const inputFilter = /[^0-9A-Za-z.,()' -]/g;
    return (
      <Text
        attribute={this.props.attribute}
        name={this.props.name}
        label={this.props.label}
        placeholder={changeablePlaceholder}
        minlength="2"
        maxlength="100"
        pattern={pattern}
        inputFilter={inputFilter}
        required={this.props.required}
        disabled={this.props.disabled}
        className={klass}
        value={this.props.value}
        onUpdate={this.props.onUpdate}
        onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        ariaLabel={this.props.ariaLabel}
        setToUpperCaseOnBlur
      />
    );
  }
}

City.defaultProps = {
  name: 'city',
  value: '',
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  required: false,
  showDisabledText: false,
};

City.errors = [];
